export default "__VITE_ASSET__DhoLsN_d__"